import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"label":_vm.$t('On empty input'),"items":_vm.searchBehaviourOptions,"item-text":"text","item-value":"value","outlined":"","dense":"","hide-details":""},model:{value:(_vm.behaviour),callback:function ($$v) {_vm.behaviour=$$v},expression:"behaviour"}})}
var staticRenderFns = []

export { render, staticRenderFns }